





























import { Component, Vue, Prop } from 'vue-property-decorator';
import { GET_PAYMENT_METHOD } from './getPaymentMethod';

@Component
export default class PaymentMethodShow extends Vue {
  private GET_PAYMENT_METHOD = GET_PAYMENT_METHOD;
  @Prop(String) private id!: string;
}
